import React, { useEffect, useState } from "react";
import "./Partner.css";
import { db } from "../../components/firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { SafeArea, Flex } from "../../components/layout";
import { Title, Text, Image } from "../../components/ui";
import { Link, useParams } from "react-router-dom";
import { HiArrowLeft } from "react-icons/hi";
import { slugify } from "../../function";
import { TbArrowRight } from "react-icons/tb";
import { logEvent, serializeError } from "../../utils/logger";

const Workshop = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchWorkshop = async () => {
      try {
        const docRef = doc(db, "partners", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          setError("L'atelier n'a pas été trouvé.");
          logEvent("WARN", "DB", "Partner not found", {
            collection: "partners",
            documentId: id,
          });
        }
      } catch (err) {
        setError("Une erreur est survenue lors du chargement de l'atelier.");
        logEvent("ERROR", "DB", "Failed to fetch partner", {
          error: serializeError(err),
          collection: "partners",
          documentId: id,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchWorkshop();
  }, [id]);

  useEffect(() => {
    if (!loading && data && window.location.hash) {
      setTimeout(() => {
        const hash = window.location.hash.substring(1);
        const headings = document.querySelectorAll("h3");

        for (let heading of headings) {
          const headingText = heading.innerText;
          const normalizedText = slugify(headingText);

          if (normalizedText === hash) {
            const elementPosition =
              heading.getBoundingClientRect().top + window.pageYOffset;
            // Ajoute un décalage de -100px
            window.scrollTo({
              top: elementPosition - 150,
              behavior: "smooth",
            });
            break; // Si on trouve une correspondance, on arrête la recherche
          }
        }
      }, 1000); // Laisse le temps que la page charge
    }
  }, [loading, data]);

  if (loading) return <Text>Chargement...</Text>;
  if (error) return <Text>{error}</Text>;

  return (
    <SafeArea className="Partner">
      <Flex>
        <Link to="/partenaires" className="back">
          <HiArrowLeft />
          Les partenaires
        </Link>
      </Flex>
      <Flex type="col" gap={30}>
        <Flex type="col-center" gap={5}>
          <Image src={data.pictureprofile} alt={data.title} />
          <Flex type="col-center">
            <Title level="h3">{data.title}</Title>
            <Text>{data.activity}</Text>
          </Flex>
        </Flex>
        <div
          className="editor"
          dangerouslySetInnerHTML={{
            __html: data.content,
          }}
        />
        <Flex type="col">
          {data.workshops &&
            data.workshops.map((workshop, index) => (
              <Link
                to={`/atelier/${slugify(workshop)}`}
                className="link"
                key={index}
              >
                <Flex gap={5}>
                  <TbArrowRight className="icon" /> <Text>{workshop}</Text>
                </Flex>
              </Link>
            ))}
        </Flex>
      </Flex>
    </SafeArea>
  );
};

export default Workshop;
